import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { API_URL } from "@/config";
import { useAuth } from "@/context/AuthProvider";
import { toast } from "sonner";

function Register() {
  const auth = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (auth?.token) navigate('/dashboard')
  }, [auth?.token, navigate])

  type Users = {
    username: string
    password: string
    email: string
  }
  const [form, setForm] = useState <Users>({
    username: "",
    email: "",
    password: ""
  })
  const [loading, setLoading] = useState (false)
  const [error, setError] = useState <string | null> (null)
  const [success, setSuccess] = useState(false)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    })
  }

  const handleSubmit = async (e: React.SyntheticEvent<HTMLFormElement>) => {
    e.preventDefault() //evita que se recargue la pagina
    setLoading(true)
    setError(null) //limpia errores de antes

    if (!form.username || !form.email || !form.password) {
      toast.error('Fill in all fields')
      setLoading(false)
      return
    }

    if (form.password.length < 8) {
      toast.error("Password must be at least 8 characters")
      setLoading(false)
      return
    }

    try {
      const res = await fetch(`${API_URL}/api/users`, {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
        // mode: 'cors',
        // credentials: 'include',
        // cache: 'no-cache',
        // redirect: 'follow',
      })

      let data: any = {}

      const text = await res.text()

      try {
        data = text ? JSON.parse(text) : {}
      } catch {
        throw new Error('No connection')
      }

      if (!res.ok) {
        toast.error(data.error ?? 'Unknown error')
        setLoading(false)
        return
      }

      setForm({ username: '', email: '', password: '' })
      navigate('/login')
      setSuccess(true)
      toast.success('User registered successfully')

    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Network error')

    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <motion.div
        initial={{ scale: 0.88, opacity: 0, y: 16 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        exit={{ scale: 0.94, opacity: 0, y: -8, transition: { duration: 0.1 } }}
        transition={{ type: "spring", stiffness: 700, damping: 25 }}
        className="page_centered"
      >

        <h2 className="relative">
          Pre-Registration
        </h2>

        <form onSubmit={handleSubmit} className="centrar_todo w-full max-w-3xs">
          <input
            type="text"
            placeholder="Username"
            name="username"
            value={form.username}
            onChange={handleChange}
            className="input"
          />

          <input
            type="email"
            placeholder="Email"
            name="email"
            value={form.email}
            onChange={handleChange}
            className="input"
          />

          <input
            type="password"
            placeholder="Password"
            name="password"
            value={form.password}
            onChange={handleChange}
            className="input"
          />

          <button disabled={loading} className="btn_si items-center">
            {loading ? "Registering..." : "Submit"}
          </button>
        </form>

      </motion.div>
    </>
  )
}

export default Register
